module.exports = __webpack_public_path__ + "static/diy_recipe_koala_cookies_thumbnail-b21b7870490b2c8410374a02f8554b80.jpg";